<template>
  <BaseButton :title="$t('button.export')" @click="isModalOpened = true" />
  <BaseCenteredModal v-model:is-modal-open="isModalOpened">
    <template #body>
      <div class="flex flex-col w-full">
        <div class="flex flex-col gap-3 w-full py-10">
          <div class="w-full">
            <SelectLocation
              v-model="localSelectedLocation"
              error-key="location_id"
              :disabled="true"
              required
             edition-mode/>
          </div>
          <div>
            <WalkmanButton v-model="exportType" :options="exportTypes" />
          </div>
          <div v-if="exportType === 'sold'" class="mt-2 flex items-center gap-4">
            <div class="shrink-0">
              <DateRangeNavigator
                  v-model:start="start"
                  v-model:end="end"
                  size="small"
              />
            </div>
            <div class="text-lg font-bold capitalize">
              {{ selectPeriod }}
            </div>
          </div>
        </div>
        <div class="flex justify-end gap-x-2">
          <BaseButton
              :title="$t('button.cancel')"
              icon="times"
              color="warning"
              @click="isModalOpened = false"
          />
          <BaseButton
            :title="'exporter'"
            icon="paper-plane"
            @click="exportStock"
          />
        </div>
      </div>
    </template>
  </BaseCenteredModal>
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import WalkmanButton from '@c/WalkmanButton.vue'
import SelectFuneralHome from '@c/InitialStateFormComponent/SelectFuneralHome.vue'
import DateRangeNavigator from '@c/SelectComponent/DateRangeNavigator.vue'
import apiClient from '@u/apiClient'
import SelectLocation from "@c/InitialStateFormComponent/SelectLocation.vue";

export default {
  name: 'ExportStock',
  components: {
    SelectLocation,
    DateRangeNavigator,
    WalkmanButton,
    BaseCenteredModal,
    BaseButton
  },
  props: {
    selectedLocation: {
      type: String,
      required: true
    },
  },
  emits: [
      'update:selected-location'
  ],
  data() {
    return {
      isModalOpened: false,
      exportType: 'available',
      start: null,
      end: null
    }
  },
  computed: {
    localSelectedLocation: {
      get() {
        return this.selectedLocation
      },
      set(value) {
        this.$emit('update:selected-location', value)
      }
    },
    exportTypes() {
      return [
        {
          value: 'available',
          label: 'Stock en cours'
        },
        {
          value: 'sold',
          label: 'Stock vendu'
        }
      ]
    },
    groupByOptions() {
      return [
        {
          value: 'fh',
          label: 'agence'
        },
        {
          value: 'site',
          label: 'site'
        }
      ]
    },
    selectPeriod() {
      if (
          this.start &&
          this.end
      ) {
        return this.$h.getDateRangeString(
            this.start,
            this.end,
            'ddd ll'
        )
      }
      return null
    }
  },
  methods: {
    async exportStock() {
      const payload = {
        location_id: this.selectedLocation,
        export_type: this.exportType,
        start: this.start,
        end: this.end
      }

      try {
        const response = await apiClient.post(
          'item/export-stocks', payload, {
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = this.exportType === 'available'
          ? 'stock_disponible.xlsx'
          : 'stock_vendu.xlsx'
        link.click()
        this.isModalOpened = false
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
